module.exports = __webpack_public_path__ + "01d75624317d326fa5ea0da28615b628.svg";